import styled from "styled-components/macro";

export const Container = styled.main`
    background-color: white;
    align-self: center;
    padding: 10px;
    height: 80vh;
    width: 40%;
    overflow: scroll;
    flex-direction: column;
`